import { render } from "./RegistrationHero.vue?vue&type=template&id=7d150d93&scoped=true"
import script from "./RegistrationHero.vue?vue&type=script&lang=js"
export * from "./RegistrationHero.vue?vue&type=script&lang=js"

import "./RegistrationHero.vue?vue&type=style&index=0&id=7d150d93&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d150d93"]])

export default __exports__